import { render, staticRenderFns } from "./CartPrice.vue?vue&type=template&id=586946ac"
import script from "./CartPrice.vue?vue&type=script&lang=ts"
export * from "./CartPrice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports